<template>
  <div class="form-group">
    <div class="form-check-inline">
      <div class="custom-control custom-checkbox">
        <input
          id="check-random-fake"
          class="form-check-input custom-control-input"
          type="checkbox"
          @change="emit"
          v-model="checkbox"
        />
        <label
          for="check-random-fake"
          class="form-check-label custom-control-label"
          >zufällig?</label
        >
      </div>
    </div>
    <div v-if="checkbox">
      <input
        id="fake-user-input-range"
        type="number"
        @input="emit"
        v-model="inputRange"
        class="form-control"
      />
      <label for="fake-user-input-range">Richtentfernung (in km)</label>
    </div>
    <div v-else>
      <autocomplete
        id="fake-user-input-id"
        v-model="inputId"
        url="/api/v1/automaticMessageRule/autocomplete"
        requestType="get"
        inputClass="form-control"
        property="name"
        @input="emit"
      ></autocomplete>
      <label for="fake-user-input-id">Fake-Profil</label>
    </div>
    <div
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import Autocomplete from "autocomplete-vue";
import { debounce } from "lodash";

export default {
  components: {
    Autocomplete
  },
  data() {
    return {
      checkbox: false,
      inputId: "",
      inputRange: 0,
      emitObj: {}
    };
  },
  mounted() {
    this.loadFake = debounce(this.loadFake, 500);
    if (this.value !== null) {
      if (this.value.name !== null) {
        this.checkbox = false;
        this.inputId = this.value.name;
      } else if (this.value.range !== null) {
        this.checkbox = true;
        this.inputRange = this.value.range;
      }

      this.emit();
    }
  },
  methods: {
    emit() {
      this.emitObj = {};
      if (this.checkbox) {
        this.emitObj.range = this.inputRange;
      } else {
        this.emitObj.id = this.inputId;
      }
      this.updateStore();

      this.$emit("input", this.emitObj);
    },
    updateStore() {
      if (!this.checkbox && this.inputId) {
        this.loadFake();
      } else {
        this.$store.commit("moderation/setFake", null);
      }
    },
    loadFake() {
      this.$store.dispatch("moderation/loadFakeByName", this.inputId);
    }
  },
  props: {
    value: {
      required: true
    },
    attribute: {
      required: true,
      type: Object
    }
  }
};
</script>
